import { IgrGridCellPosition } from "./igr-grid-cell-position";
import { GridActiveCellChangedEventArgs as GridActiveCellChangedEventArgs_internal } from "./GridActiveCellChangedEventArgs";
/**
 * Information about the change to the selected cells in the grid.
*/
var IgrGridActiveCellChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridActiveCellChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridActiveCellChangedEventArgs.prototype.createImplementation = function () {
        return new GridActiveCellChangedEventArgs_internal();
    };
    Object.defineProperty(IgrGridActiveCellChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridActiveCellChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridActiveCellChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridActiveCellChangedEventArgs.prototype, "newActiveCell", {
        /**
         * The new active cell.
        */
        get: function () {
            if (this.i.newActiveCell == null) {
                return null;
            }
            if (!this.i.newActiveCell.externalObject) {
                var e = new IgrGridCellPosition();
                e._implementation = this.i.newActiveCell;
                this.i.newActiveCell.externalObject = e;
            }
            return this.i.newActiveCell.externalObject;
        },
        set: function (v) {
            v == null ? this.i.newActiveCell = null : this.i.newActiveCell = v.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridActiveCellChangedEventArgs.prototype, "oldActiveCell", {
        /**
         * The old active cell.
        */
        get: function () {
            if (this.i.oldActiveCell == null) {
                return null;
            }
            if (!this.i.oldActiveCell.externalObject) {
                var e = new IgrGridCellPosition();
                e._implementation = this.i.oldActiveCell;
                this.i.oldActiveCell.externalObject = e;
            }
            return this.i.oldActiveCell.externalObject;
        },
        set: function (v) {
            v == null ? this.i.oldActiveCell = null : this.i.oldActiveCell = v.i;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridActiveCellChangedEventArgs;
}());
export { IgrGridActiveCellChangedEventArgs };
//# sourceMappingURL=igr-grid-active-cell-changed-event-args.js.map
